import { elements } from '../modernizr-webp';

const bodyScrollLock = require('body-scroll-lock');

const handleCheckboxChange = function(checkboxElement) {
    if (checkboxElement.checked == true) {
        document.querySelectorAll('.mobile-menu__scroll-area').forEach(element => {
            bodyScrollLock.disableBodyScroll(element);
        })
        return;
    }
    document.querySelectorAll('.mobile-header-menu__sub-menu-checkbox').forEach(element => {
        element.checked = false;
    })
    document.querySelectorAll('.mobile-menu__scroll-area').forEach(element => {
        bodyScrollLock.enableBodyScroll(element);
    })
}

window.addEventListener("pagehide", event => {
    bodyScrollLock.clearAllBodyScrollLocks();
});

const setupSubMenuRadios = function() {
    const backButtons = document.querySelectorAll('.header-sub-menu__back-button');
    backButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            // find the closest .header-sub-menu__container parent and then find the .header-sub-menu__mobile-link-radio--off within it and check it
            const offRadio = event.target.parentElement.parentElement.querySelector('.header-sub-menu__mobile-link-radio--off');
            if (!offRadio) {
                console.error('Back button is not inside a .header-sub-menu__container');
                return;
            }
            offRadio.checked = true;
            bodyScrollLock.clearAllBodyScrollLocks();
            const lockElement = button.parentElement;
            if (!lockElement) {
                console.error('Back button is not inside a .header-sub-menu__container');
                return;
            }
            const parentLockElement = lockElement.parentElement;
            if (parentLockElement && parentLockElement.classList.contains('header-sub-menu__container')) {
                bodyScrollLock.disableBodyScroll(parentLockElement);
            }
        });
    });

    document.querySelectorAll('.header-sub-menu__mobile-link-radio').forEach(element => {
        element.addEventListener('change', function() {
            if (this.checked == true) {
                bodyScrollLock.clearAllBodyScrollLocks();
                if (this.value == '') {
                    document.querySelectorAll('.mobile-menu__scroll-area').forEach(element => {
                        bodyScrollLock.disableBodyScroll(element);
                    });

                    return;
                }
                const lockElement = element.nextElementSibling.nextElementSibling;
                bodyScrollLock.disableBodyScroll(lockElement);
                return;
            }
        });
    });
}

export default function() {
    const checkboxElement = document.querySelector('#mobile-header-menu__burger-checkbox');
    if (!checkboxElement) {
        return;
    }
    handleCheckboxChange(checkboxElement);
    checkboxElement.addEventListener('change', function() {
        handleCheckboxChange(checkboxElement);
    });
    setupSubMenuRadios();
}